import React, { FC } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  CatHeadArrowCont,
  PredictiveColumnTitle,
  PredictiveStatesTitle,
  ReportPredictiveStatesTileHeaderCont,
  SortHeaderCont,
} from './ReportPredictiveStatesHeader.styles';
import { getScoreSortFilters } from '../../../helpers/helpers';
import { useFilters } from '../../../hooks/useFilters';
import { useNestedSort } from '../../../hooks/useNestedSort';
import Arrow from '@/assets/icons/filledDownArrow.svg?react';

interface IReportPredictiveStatesHeader {
  sortKey: string;
  isTotalsTabActive: boolean;
}

const ReportPredictiveStatesHeader: FC<IReportPredictiveStatesHeader> = ({
  sortKey,
  isTotalsTabActive,
}) => {
  const { t } = useTranslation();
  const { currentFilters } = useFilters();
  const { key, value } = getScoreSortFilters(currentFilters, 'predictiveStates', sortKey);
  const { manageTripleSortState } = useNestedSort(
    { score: value || null },
    sortKey,
    'predictiveStates'
  );
  const scoreStateActive = key === 'score' && value === 'asc';
  const scoreStateInActive = key === 'score' && value !== 'asc' && value !== 'desc';

  return (
    <ReportPredictiveStatesTileHeaderCont id="ReportPredictiveStatesTileHeaderCont" first>
      <PredictiveStatesTitle id="PredictiveStatesTitle">
        {t('report.results.topic')}
      </PredictiveStatesTitle>
      {!_.isEmpty(sortKey) && isTotalsTabActive && (
        <SortHeaderCont id="SortHeaderCont">
          <PredictiveColumnTitle id="PredictiveColumnTitle">
            <CatHeadArrowCont
              data-testid="CatHeadArrowCont"
              onClick={() => manageTripleSortState('score')}
              inActive={scoreStateInActive}
              active={scoreStateActive}
            >
              {t('report.results.score')}
              <Arrow />
            </CatHeadArrowCont>
          </PredictiveColumnTitle>
        </SortHeaderCont>
      )}
    </ReportPredictiveStatesTileHeaderCont>
  );
};

export default ReportPredictiveStatesHeader;
